import { IocRegistration } from '@mchs/web-core';
import { Container } from 'inversify';
import MessengerService, { MESSENGER_SERVICE_TYPES } from './messengerService';
import IgnoreMessengerService from './ignoreMessengerService';
import PostMessengerService from './postMessengerService';

class MessengerServiceRegistration extends IocRegistration {
  constructor(container: Container) {
    super(container, 'Messenger Service');
  }

  protected registerProduction(): string {
    return this.registerPost();
  }

  protected registerTest(): string {
    return this.registerIgnore();
  }

  protected registerDebug(): string {
    return this.registerPost();
  }

  private registerIgnore(): string {
    this.container
      .bind<MessengerService>(MESSENGER_SERVICE_TYPES.MessengerService)
      .to(IgnoreMessengerService);

    return 'Ignore';
  }

  private registerPost(): string {
    this.container
      .bind<MessengerService>(MESSENGER_SERVICE_TYPES.MessengerService)
      .to(PostMessengerService);

    return 'Post Message';
  }
}

export default MessengerServiceRegistration;
